import React from 'react';

export default function UserGeneratedContentPolicy() {
  return (
    <div className="bg-white min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto space-y-10 text-gray-800">

        <h1 className="text-3xl font-bold text-purple-600 text-center">User-Generated Content Policy</h1>

        <p className="text-gray-700">
          This policy governs all content submitted, posted, or published by users within the Million2Trillion (M2T) platform.
        </p>

        <div className="bg-white border border-purple-200 rounded-2xl shadow p-8 space-y-7">

          <div>
            <h2 className="text-2xl font-semibold text-purple-500 mb-2">Content Ownership</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>Users retain full ownership of their original content posted to M2T (including articles, educational material, trading ideas, or market opinions).</li>
              <li>By submitting content, users grant M2T a worldwide, royalty-free, non-exclusive license to display, share, promote, or redistribute that content for platform purposes.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-purple-500 mb-2">Content Responsibility</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>Users are fully responsible for the accuracy, legality, and originality of the content they publish.</li>
              <li>Users agree not to submit content that violates intellectual property, copyright, trademark, or confidentiality rights of any third party.</li>
              <li>Users must avoid posting fake signals, unverified market advice, or misleading information that may harm other users or the platform’s integrity.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-purple-500 mb-2">Prohibited Content</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li>Hate speech, harassment, or abusive behavior</li>
              <li>Fraudulent or manipulative investment advice</li>
              <li>Adult, obscene, or explicit materials</li>
              <li>Unlicensed promotional advertisements or external sales</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-purple-500 mb-2">Content Moderation</h2>
            <p>
              All user-generated content is subject to moderation by M2T content teams, AI moderation engines, or third-party compliance reviewers.
              M2T reserves the right to edit, restrict, suspend, or delete any content violating platform standards.
            </p>
          </div>

        </div>

        <p className="text-gray-400 italic text-sm text-center">
          By contributing content, you agree to follow this policy as part of our global verified financial system.
        </p>
      </div>
    </div>
  );
}
